import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SlidePanelService {
  // Panel visibility state
  private panelState$ = new BehaviorSubject<boolean>(false);
  private panelCanUse$ = new BehaviorSubject<boolean>(false);

  /** Observable stream for visibility */

  get state$(): Observable<boolean> {
    return this.panelState$.asObservable();
  }

   get canUsePanel$(): Observable<boolean> {
    return this.panelCanUse$.asObservable();
  }

  /** Returns current visibility state */

  get isOpen(): boolean {
    return this.panelState$.getValue();
  }

  get canUsePanel(): boolean {
    return this.panelCanUse$.getValue();
  }

  /** Opens the panel */

  open(): void {
    this.panelState$.next(true);
  }

  /** Closes the panel */

  close(): void {
    this.panelState$.next(false);
  }

  /** Toggles the panel state */

  toggle(): void {
    this.panelState$.next(!this.panelState$.getValue());
  }

  /** Set explicit visibility (useful for route-based toggling) */

  setPanelStatus(open: boolean){
    this.panelState$.next(open);
  }

  setCanUse(useit: boolean): void {
    this.panelCanUse$.next(useit);
  }
}
